import React, { Component } from "react";
import '../css/documentation.scss';

export class ViewCareerHelp extends Component {
    render() {
        return (
            <div className="main-content">
                <div className="section__content section__content--p30 createContent">
                    <div className="container-fluid">
                        <h1 style={{ fontSize: '36px', marginTop: '30px' }}>How To View Career Details</h1>
                        <p className="dateFormat" style={{ fontSize: '14px', color: 'grey' }}>18/11/2021 ▪ 2 minutes to read</p>
                        <br /><br />
                        <div class="webMgmt container-fluid">
                            <ol>
                                <li class="createList">
                                    Using the menu on the left, click on "Website Management", then click on the “Careers” link. This will take you to the Careers Listing Page.   <br />
                                    <img src="/img/documentation-img/CareersImg/nav_careers.png" class="userImage" />
                                </li>
                                <li class="createList">
                                    In the Careers Listing Page, click on any career listing of your choice. This will take you to the View Career Details. <br />
                                    <img src="/img/documentation-img/CareersImg/career_select.png" class="userImage" />
                                </li>

                                <li class="createList">
                                    In Careers Details Page, you will be able to see the following fields:
                                    <ul class="unorderedList">
                                        <li>
                                            Career Title
                                        </li>
                                        <li>
                                            Display Weight
                                        </li>
                                        <li>
                                            Display Start
                                        </li>
                                        <li>
                                            Display End
                                        </li>
                                        <li>
                                            Short Description
                                        </li>
                                        <li>
                                            Responsibilities
                                        </li>
                                        <li>
                                            Requirements
                                        </li>
                                        <li>
                                            Long Description
                                        </li>

                                    </ul>
                                    <div class="alert alert-primary" role="alert">
                                        <i class="fas fa-info-circle" aria-hidden="true"></i>
                                        <strong class="noteHeader">Information:</strong><br/><br/>
                                            - Display weight determines how the item will be displayed. The lower the display weight, the higher it will place on the website.<br />
                                            - Display Start DateTime should always be earlier than Display End DateTime.<br />
                                            - Short Description, Responsbilities, Requirements, and Long Description should be in HTML format.
                                </div>
                            </li>
                            </ol>
                            <div className="text-right">
                                <a href="/documentation/careers/CreateCareerHelp" className="btn btn-primary">Create Careers &raquo;</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}